<template>
  <LayoutGradient :title="$t('dexpara.metodo.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaSimpleFilter @search="searchMethods"/>

        <TableSimple
            :fields="fields"
            :items="methods"
            :loading="isLoading || DeXParaIsLoading"
            :paginator="pagination"
            :text-empty="$t('dexpara.metodo.empty')"
            thead-class="h5 text-center"
            @paginate="paginateMethods"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <b-form-group :label="linha.item.name">
              <b-form-input
                  :id="`input-origem-${linha.index}`"
                  :disabled="!integrationsSelected.origin"
                  v-model="linha.item.origin_code"
                  trim
              />
              <b-button size="sm" variant="link" @click="openLogs(linha);" class="mb-0 p-0" v-if="permissions.includes('logs.detail')">
                {{ $t('dexpara.filtros.logs') }}
              </b-button>
            </b-form-group>
          </template>
          <template v-slot:cell(destination)="{item, index}">
            <b-form-group :label="item.name">
              <b-form-input
                  :id="`input-destino-${index}`"
                  :disabled="!integrationsSelected.destination"
                  v-model="item.destination_code"
                  trim
              />
            </b-form-group>
          </template>
          <template #row-details="{ item, index }">            
            <b-card :title="$t('dexpara.log.origem')">
              <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
            </b-card>
            <b-card :title="$t('dexpara.log.destino')" class="mt-2">
              <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
            </b-card>
          </template>
        </TableSimple>
      </b-card>

      <DeXParaIntegrations class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara"/>

    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaSimpleFilter from "@/pages/dexpara/components/DeXParaSimpleFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import DeXParaRepository from "@/repositories/dexpara/MethodRepository";
import {mapActions, mapGetters} from 'vuex';
import TableSimple from "@/components/TableSimple";
import DeXParaIntegrations from "@/pages/dexpara/components/DeXParaIntegrations";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaMetodo",
  components: {
    DeXParaIntegrations,
    TableSimple,
    DeXParaSimpleFilter,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      DeXPara: 'dexpara/method/all',
      DeXParaIsLoading: 'dexpara/method/isLoading',

      methods: 'tuevs/method/all',
      isLoading: 'tuevs/method/isLoading',
      pagination: 'tuevs/method/pagination',
      filters: 'dexpara/filters'
    })
  },
  data() {
    return {
      integrationsSelected: {
        origin: null,
        destination: null
      },
      fields: [
        {key: 'origin', label: this.$t('dexpara.metodo.origem')},
        {key: 'destination', label: this.$t('dexpara.metodo.destino')}
      ],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'integration/search',
      'dexpara/method/listAll',
      'tuevs/method/listAll'
    ]),
    async openLogs(linha) {
      if (linha.detailsShowing === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);
      }      

      linha.toggleDetails();
    },
    async formatLogDetails(method) {
      let obj = {}
      let logOrigin = null
      let logDestination = null
      if (!this.DeXPara || this.DeXPara.length === 0) {
        return obj
      }

      let originMapped = this.DeXPara.filter(d => d.tuevs_method_id === method.id && d.code === method.origin_code);
      let destinationMapped = this.DeXPara.filter(d => d.tuevs_method_id === method.id && d.code === method.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].id).then(async (response) => {          
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateMethods(pagination) {
      await this.$store.commit('tuevs/method/setPagination', {
        ...this.pagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchMethods()
    },
    async searchMethods() {
      let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code_mapping");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
        }
      }

      await this['tuevs/method/listAll']({...this.pagination, filters: filterApi})
      await this.searchDeXparas()
      this.loadIntegrationsCodes()
    },
    async searchDeXparas() {
      let filters = [
        ['tuevs_method_id', 'IN', this.methods.reduce((accumulator, current) => [...accumulator, current.id], [])],
        ['vns_integration_id', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]
      ]
      if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
        await this['dexpara/method/listAll']({
          per_page: this.pagination.per_page * 2,
          filters
        })
      }
    },
    getMethodsOfIntegration(integration_id) {
      const methods = this.DeXPara.filter(method => {
        return method.vns_integration_id === integration_id
      })

      if (methods.length > 0) {
        return methods
      }

      return []
    },
    getDeXpara(tuevs_method_id, integration_id) {
      if (this.DeXPara && Array.isArray(this.DeXPara)) {
        return this.DeXPara.find(method => {
          return method.vns_integration_id === integration_id && method.tuevs_method_id === tuevs_method_id
        })
      }
      return null
    },
    loadIntegrationsCodes() {
      if (this.methods && Array.isArray(this.methods)) {
        const methods = this.methods.map(method => {
          const origin_mapped = this.getDeXpara(method.id, this.integrationsSelected.origin)
          method.origin_code = origin_mapped && origin_mapped.code ? origin_mapped.code : null

          const destination_mapped = this.getDeXpara(method.id, this.integrationsSelected.destination)
          method.destination_code = destination_mapped && destination_mapped.code ? destination_mapped.code : null

          return method
        })
        this.$store.commit('tuevs/method/setAll', methods)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected.origin = this.integrationsSelected.destination = null

      let originLabel = this.$t('dexpara.metodo.origem')
      if (evt.origin) {
        originLabel = evt.origin.label
        this.integrationsSelected.origin = evt.origin.value
      }

      let destinationLabel = this.$t('dexpara.metodo.destino')
      if (evt.destination) {
        destinationLabel = evt.destination.label
        this.integrationsSelected.destination = evt.destination.value
      }

      this.fields = [{key: 'origin', label: originLabel}, {key: 'destination', label: destinationLabel}]
      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async persistDeXPara() {
      let parsedIntegrations = []

      if (this.integrationsSelected.origin) {
        let integrationId = this.integrationsSelected.origin
        this.methods.filter(m => m.origin_code !== null)
            .map(method => {
              let dexpara = {tuevs_method_id: method.id, integrations: [{id: integrationId, code: method.origin_code}]}
              if (this.getDeXpara(method.id, integrationId) && method.origin_code === '') {
                dexpara = {...dexpara, integrations: [integrationId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (this.integrationsSelected.destination) {
        let integrationId = this.integrationsSelected.destination
        this.methods.filter(m => m.destination_code !== null)
            .map(method => {
              let dexpara = {tuevs_method_id: method.id, integrations: [{id: integrationId, code: method.destination_code}]}
              if (this.getDeXpara(method.id, integrationId) && method.destination_code === '') {
                dexpara = {...dexpara, integrations: [integrationId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (parsedIntegrations.length > 0) {
        await DeXParaRepository.post({methods: parsedIntegrations}).then(async () => {
          this.$snotify.success(this.$t('dexpara.metodo.sucesso'))
          await this.searchMethods()
          await this.searchDeXparas()
        })
      }
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    await this['tuevs/method/listAll'](this.pagination)
    await this['integration/search']()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}
</style>
